export enum UnavailableDaySeverity {
  SEV1 = 'severity-1',
  SEV2 = 'severity-2',
  SEV3 = 'severity-3',
  SEV4 = 'severity-4',
  SEV5 = 'severity-5',
  SEVX = 'severity-x',
}
